export default __webpack_public_path__ + "static/media/FTM.f5a88398.png";